import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Group } from '../models/user-manager/group';
import { ApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class GroupProxyService {
  private baseUrl = `${environment.proxyUrls.userMasterApi}/api/v1/group`;
  constructor(private httpClient: HttpClient) {}

  getAllGroups(): Observable<ApiResponse<Group[]>> {
    return this.httpClient.get<ApiResponse<Group[]>>(`${this.baseUrl}/all`);
  }

  getGroupById(id: string): Observable<ApiResponse<Group>> {
    return this.httpClient.get<ApiResponse<Group>>(`${this.baseUrl}/${id}`);
  }

  createGroup(group: Group): Observable<ApiResponse<Group>> {
    return this.httpClient.post<ApiResponse<Group>>(`${this.baseUrl}`, group);
  }

  updateGroup(group: Group): Observable<ApiResponse<Group>> {
    return this.httpClient.put<ApiResponse<Group>>(`${this.baseUrl}/${group.id}`, group);
  }

  updateRolesGroup(idRoles: string[], idGroup: string): Observable<ApiResponse<Group>> {
    return this.httpClient.put<ApiResponse<Group>>(`${this.baseUrl}/${idGroup}/update-roles`, idRoles);
  }

  deleteGroup(id: string): Observable<ApiResponse<string>> {
    return this.httpClient.delete<ApiResponse<string>>(`${this.baseUrl}/${id}`);
  }
}
